import {
    DOCUMENTOS,
    DOCUMENTOS_SUCCESS,
    DOCUMENTOS_FAIL,
    LISTA_DOCUMENTOS,

    DOCUMENTO_ADICIONADO,
    DOCUMENTO_ADICIONADO_FAIL,
    
    SIG,
    SIG_SUCCESS,
    SIG_FAIL,

    DOC_SELECTED,
    DOC_NOT_SELECTED,

    SIG_CONTATAR_SUCCESS,
    SIG_CONTATAR_FAIL,

    SIG_REMOVE,

    EXIBIR_DOC,
    EXIBIR_DOC_SUCCESS,
    EXIBIR_DOC_FAIL,

    BAIXAR_DOC,

    CHANGE_STATUS,
    CHANGE_STATUS_SUCCESS,
    CHANGE_STATUS_FAIL,

    LIMPA_MSGS,

    EXIBIR_EVIDENCIA,
    EXIBIR_EVIDENCIA_SUCCESS,
    EXIBIR_EVIDENCIA_FAIL,
    AGRUPADOR,
    ADDSTATE
} from './types'
import api from './api';

import { downloadPDF, toastMessage } from '../utils/Utils'
import moment from 'moment';

export const addDocumento = (file, dados , callback) => {
    return dispatch => {
        dispatch({ type: DOCUMENTOS })
        let { extra_info, agrupador, numero } = dados
        let param = new FormData()
        param.append('arquivo',file)
        param.append('extra_info', '')
        param.append('numero', numero)
        param.append('tag', agrupador)

        console.log('=> DATA ATUAL 1: ', moment().format())
        console.log('=> DATA ATUAL 2: ', moment().format('YYYY-MM-DD HH:mm:ss'))

        api.post('documentos',param).then( res => {
            dispatch({ type: DOCUMENTO_ADICIONADO, payload: res.data.payload.documento })
            callback(true)
        }).catch( err => {
            if(err.response != undefined){
                err = err.response.data
                dispatch({ type: DOCUMENTO_ADICIONADO_FAIL, payload: err.message })
            }
            callback(false)            
        })
    }
}

export const listaDocumentos = (params/*filtro = null*/) => {
    return dispatch => {
        dispatch({ type: LISTA_DOCUMENTOS })
        var formData = new FormData()

        for( let i in params)
            if(params[i])
                formData.append(i, params[i])

        if(!('limit' in params))
            formData.append('limit', 10)
            
        // console.log('======== DOCUMENTOS - PARAMS: ', params)
        api.post('documentos/list', formData).then( res => {
            var documentos = res.data.payload.documentos
            var paginate = {
                total: res.data.payload.total,
                perPage: res.data.payload.perPage,
                page: res.data.payload.page,
                lastPage: res.data.payload.lastPage
            }
            //window.digdin = documentos
            // if(filtro != null) {
            //     switch(filtro.por){
            //         case 'nome':
            //             filtro.search = filtro.search.toLowerCase()
            //             documentos = documentos.filter( v => v.titulo.toLowerCase().includes(filtro.search) || v.status.toLowerCase().includes(filtro.search) )
            //             break;
            //         case 'status':
            //             documentos = documentos.filter( v => v.status == filtro.search)
            //             break;
            //         case 'advanced':
            //             if(filtro.tag != '' && filtro.tag != undefined)
            //                 documentos = documentos.filter( v => v.tag == filtro.tag)

            //             if(filtro.nome != '' && filtro.nome != undefined){
            //                 documentos = documentos.filter( v => {
            //                     const titulo =  v.titulo.toLowerCase()
            //                     const extra =  v.numero != undefined && v.numero != null ? v.numero.toLowerCase() : ''
            //                     if( titulo.includes(filtro.nome.toLowerCase()) || extra.includes(filtro.nome.toLowerCase()) )
            //                         return v
            //                 })
            //             }
                                                        
                        
            //             break;
            //         default:
            //             documentos = []
            //             break;
            //     }
            // }

            dispatch({ type: DOCUMENTOS_SUCCESS, payload: { documentos, paginate } })
            window.feather.replace()

        }).catch( err => {
            if(err.response != undefined){
                err = err.response.data
                dispatch({ type: DOCUMENTOS_FAIL, payload: err.message })
            }

        })
    }
}

export const addSigDoc = (doc, sig, callback) => {
    return dispatch => {
        dispatch({ type: SIG })
        
        let params = new FormData()
        for(let i in sig){
            params.append(i,sig[i])
        }
        
        api.post(`documentos/addSig/${doc.id}`,params).then( res => {
           // console.log('RES:',res)
            dispatch({ type: SIG_SUCCESS, payload: res.data.message })
            callback(res.data.erro)
       
        }).catch( err => {
            console.log('Error:',err)
            err = err.response.data

            dispatch({ type: SIG_FAIL, payload: err.message })
            
            callback(err.erro)
        })

    }
}

export const select_doc = (doc) => {
    return dispatch => {
        dispatch({ type: DOC_SELECTED, payload: doc})
    }
}

export const selected_doc_remove = () => {
    return dispatch => {
        dispatch({ type: DOC_NOT_SELECTED })
    }
}

export const buscaDocumento = (id, callback = () => null) => {
    return dispatch => {

        dispatch({ type: DOCUMENTOS })

        api.get(`documentos/infos/${id}`).then( res => {
            //console.log('RES:',res)
            dispatch({ type: DOCUMENTO_ADICIONADO, payload: res.data.payload.documento })
            callback(true)
       
        }).catch( err => {
            console.log('Error:',err)
            if(err.response != undefined) {
                err = err.response.data
                dispatch({ type: DOCUMENTO_ADICIONADO_FAIL, payload: err.message })
            }
            callback(false)

        })
    }
}

export const removeSigDoc = (doc_id,sig_id, callback) => {
    return dispatch => {

        dispatch({ type: SIG_REMOVE })
        
        let param = new FormData()
        param.append('signatario_id',sig_id)

        api.patch(`signatario/${doc_id}`,param).then( res => {
            //console.log('RES:',res)            
            dispatch({ type: SIG_REMOVE, payload: res.data.message })
            callback(true)
        }).catch( err => {
            console.log('Error:',err)
            if(err.response != undefined) {
                err = err.response.data
                dispatch({ type: SIG_REMOVE, payload: err.message })
                callback(false)
            }

        })
    }
}

export const contatarSignatario = (doc_id,sig_id, type = 'email', callback) => {
    return dispatch => {

        dispatch({ type: SIG })
        
        let param = new FormData()
        param.append('signatario_id',sig_id)
        param.append('documento_id',doc_id)

        api.post(`signatario/${
            type === 'email' ? 'sendEmail' 
            : type === 'whatsapp' ? 'sendWhatsApp' 
            : 'sendSMS'}`,param)
            .then( res => {
            //console.log('RES:',res)
            dispatch({ type: SIG_CONTATAR_SUCCESS, payload: res.data.message })
            callback(res.data.erro)
        }).catch( err => {
            console.log('Error:',err)
            if(err.response != undefined) {
                err = err.response.data
                dispatch({ type: SIG_CONTATAR_FAIL, payload: err.message })
                callback(true)
            }

        })
    }
}

export const exibirDocumento = ( id ) => {
    return dispatch => {

        dispatch({ type: EXIBIR_DOC })
        

        api.get(`/documentos/exibir/${id}`,{
            // responseType: 'arraybuffer',
            // dataType:'blob'
        }).then( res => {
            const { base64pdf } = res.data.payload
            //console.log('RES:',res)
            dispatch({ type: EXIBIR_DOC_SUCCESS, payload: base64pdf })

        }).catch( err => {
            console.log('Error:',err)
            var msg = ''
            if(err.response != undefined) {
                err = err.response.data
                msg  = err.message
            }

            dispatch({ type: EXIBIR_DOC_FAIL, payload: msg })


        })
    }
}

export const baixarDocumento = ( doc, tipo = 'documento', callback ) => {
    return dispatch => {

        dispatch({ type: DOCUMENTOS })     

        api.post(`/documentos/download`, { id :doc.id, tipo }, {
            headers:{
                
            },
            responseType: 'arraybuffer',
            dataType:'blob'
        }).then( res => {
            //console.log('RES:', res )
            //force download
            downloadPDF(res.data,`${doc.titulo}.${doc.extensao}`)

            dispatch({ type: BAIXAR_DOC, payload: '' })
            callback(false)

        }).catch( err => {
            console.log('Error:',err)
           
            var msg = 'Não foi possivel baixar o documento.'
            if(err.response != undefined) {
                err = err.response.data
                msg = err.message
            }

            dispatch({ type: BAIXAR_DOC, payload: msg })
            callback(true)

        })
    }
}

export const changeStatus = (id, status, dataLimite, callback, stealthMode = false) => {
    return dispatch => {
        dispatch({ type: CHANGE_STATUS })
        
        let params = new FormData()
        params.append('status',status)
        params.append('stealthMode', stealthMode)
        //params.append('dataLimite',dataLimite)

        api.put(`/documentos/${id}`,params).then( res => {
            //console.log('RES:', res )
            res = res.data

            dispatch({ type: CHANGE_STATUS_SUCCESS, payload: res.payload.documento, message: res.message })
            callback(false)

        }).catch( err => {
            console.log('Error:',err)
           
            var msg = 'Não foi possivel realizar está operação.'
            if(err.response != undefined) {
                err = err.response.data
                msg = err.message
            }

            dispatch({ type: CHANGE_STATUS_FAIL, payload: msg })
            callback(true)

        })
    }
}

export const limpa_msgs = () => {
    return dispatch => { dispatch({ type: LIMPA_MSGS}) }
}

export const exibirEvidencia = (cpfCnpj,documento_id, categoria = 'assinatura') => {
    return dispatch => {
        dispatch({ type: EXIBIR_EVIDENCIA})

        let params = new FormData()
        params.append('cpfcnpj', cpfCnpj)
        params.append('categoria', categoria)
        params.append('documento_id', documento_id)
        api.post('arquivo/evidencia', params,{
            // responseType:'arraybuffer',
            // type:'blob'
        }).then( res => {
            //console.log('RES:',res)
            const { base64file } = res.data.payload
            dispatch({ type: EXIBIR_EVIDENCIA_SUCCESS, payload: res.data.payload })
        }).catch( error => {
            dispatch({type: EXIBIR_EVIDENCIA_FAIL})
        })
    }
}

export const addAgrupador = (titulo,descricao, callback = () => null) => {
    return dispatch => {
        dispatch({ type: AGRUPADOR, payload: { load_agrupador: true, error_doc:'' }})

        let params = new FormData()
        params.append('titulo', titulo)
        params.append('descricao', descricao)
        api.post('tag', params ).then( res => {
            const { message } = res.data.payload
            dispatch({ type: AGRUPADOR, payload: { load_agrupador: false, agrupador_success: message, error_doc:'' }})
            callback(true)
        }).catch( error => {
            const { data } = error.response
            const { message } = data || {}
            dispatch({ type: AGRUPADOR, payload: { load_agrupador: false, error_doc: message || "Erro ao cadastrar novo agrupador!" }})
            callback(false)
        })
    }
}

export const getAgrupador = () => {
    return dispatch => {
        dispatch({ type: AGRUPADOR, payload: { load_agrupador: true, error_doc:'' }})

        api.get('tag' ).then( res => {
            const { tags } = res.data.payload
            dispatch({ type: AGRUPADOR, payload: { load_agrupador: false, tags }})
        }).catch( error => {
            const { data } = error.response
            const { message } = data || {}
            dispatch({ type: AGRUPADOR, payload: { load_agrupador: false, error_doc: message || "Erro ao buscar grupos" }})
        })
    }
}

export const removeAgrupador = (descricao, callback = () => null) => {
    return dispatch => {
        dispatch({ type: AGRUPADOR, payload: { load_agrupador: true, error_doc:'' }})

        api.delete('tag', {data: { descricao }}).then( res => {
            const { message } = res.data
            toastMessage('success',message)
            dispatch({ type: AGRUPADOR, payload: { load_agrupador: false, message }})            
            callback(true)
        }).catch( error => {
            const { data } = error.response
            const { message } = data || {}
            dispatch({ type: AGRUPADOR, payload: { load_agrupador: false, error_doc: message || "Erro ao buscar grupos" }})
            toastMessage('error',message)
            callback(false)
        })
    }
}

export const getCarimbo = (id, callback = () => null) => {
    return dispatch => {
        dispatch({ type: AGRUPADOR, payload: { load_carimbo: true, error_doc:'' }})

        api.get('documentos/carimbo/'+id ).then( res => {
            const { base64pdf } = res.data.payload
            dispatch({ type: AGRUPADOR, payload: { load_carimbo: false }})
            downloadPDF(base64pdf,'carimbo','base64')
            callback(true)
        }).catch( error => {
            const { data } = error.response
            const { message } = data || {}
            dispatch({ type: AGRUPADOR, payload: { load_carimbo: false, error_doc: message || "Erro ao buscar grupos" }})
            callback(false)
        })
    }
}

export const addDados = (dados) => {
    return dispatch => {
        dispatch({ type: ADDSTATE, payload: dados })
    }
}